/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 30.10.17.
 */

import _ from "underscore";
import DataProvider from "../../../DataProvider";

import * as formValidators from "./Validator";

class FormValidator {
    /**
     *
     * @param {Object} props
     * @param {Schema} schema
     */
    constructor(props, schema) {
        this.props = props;
        /**
         * @type {Schema}
         */
        this.schema = schema;
        this.validators = [];
        this.loadValidators(this.schema);
    }

    /**
     * Load validators from schema
     * @param {Schema} schema
     */
    loadValidators(schema) {
        this.validators.push([null, this.getValidatorObject(schema, "RequiredValidator")]);

        let validator = schema.getValidator();
        if (validator != null) {
            if (!_.isArray(validator)) validator = [validator];
            for (let v of validator) {
                this.validators.push([null, this.getValidatorObject(schema, v)]);
            }
        }

        let fields = schema.getFieldList();
        if (fields != null && fields.length > 0) {
            for (let field of fields) {
                let fieldSchema = schema.field(field);

                let validator = fieldSchema.getValidator();
                if (validator != null) {
                    if (!_.isArray(validator)) validator = [validator];
                    for (let v of validator) {
                        this.validators.push([field, this.getValidatorObject(fieldSchema, v)]);
                    }
                }
            }
        }
    }

    /**
     *
     * @param {Object} formData
     * @param {Object} errors
     * @returns {boolean} True if there were errors
     */
    validate(formData, errors) {
        let dataProvider = new DataProvider(this.schema, formData);
        let isError = false;
        for (let v of this.validators) {
            let field = v[0];
            let validator = v[1];
            if (!validator) continue;

            let data = dataProvider.getValue(field);
            let result = validator.validate(data);
            if (result != null) {
                if (!_.isArray(result)) result = [result];
                for (let r of result) {
                    if (field == null) {
                        if (_.isString(r)) {
                            if (errors) {
                                errors.addError(r);
                                isError = true;
                            }
                        }
                        else {
                            for (let f of _.keys(r)) {
                                if (errors[f]) {
                                    errors[f].addError(r[f]);
                                    isError = true;
                                }
                            }
                        }
                    }
                    else {
                        if (_.isString(r)) {
                            if (errors[field]) {
                                errors[field].addError(r);
                                isError = true;
                            }
                        }
                        else {
                            for (let f of _.keys(r)) {
                                if (errors[field]) {
                                    errors[field].addError(r[f]);
                                    isError = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        return isError;
    }

    getValidatorObject(schema, name) {
        let ValidatorClass = this.getValidator(name);
        if (!ValidatorClass) return null;
        return new ValidatorClass(this.props, schema);
    }

    getValidator(name) {
        return formValidators[name];
    }
}

export default FormValidator;
